import { useState } from "react";
import ReactDOM from "react-dom";
import Button from "../../../common/Button";

import classes from './ExportWorkQ.module.css'
import Backdrop from "../../../common/modal/Backdrop";
import Modal from "../../../common/Modal";
import ModalInnerWrapper from "../../../common/ModalInnerWrapper";
import PannelBody from "../../../fragments/PannelBody";
import { useDispatch, useSelector } from "react-redux";
import ExportWorkQGroupContainer from "./ExportWorkQGroupContainer";

import { useUserTabEditPermissionDisabled } from "../../../../lib/usersPermissions";
import BodySimpleModalV3 from "../../../common/modal/BodySimpleModalV3";
import { notificationActions } from "../../../../store/notifications";
import { exportStandardWorkQ } from "../../../../lib/fetchApi";

export default function ExportWorkQ({workq, inMenu, closeHamburgerMenuHandler}) {
    const dispatch = useDispatch()
    const [showModal, setShowModal] = useState(false)
    const [loading, setLoading] = useState(false)
    const [filtersData, setFilters] = useState(null)
    

    let userPermissionDisabled = useUserTabEditPermissionDisabled('work_queues_export')

    const selectedFilters = useSelector(state => state.filter.filters)
    const selectedExceptions = useSelector(state => state.filter.exceptions)
    const searchParams = useSelector(state => state.filter.searchParams)
    const orderFilters = useSelector(state => state.filter.orderFilters)

    const userToken = useSelector(state => state.user.token)


    function openModalHandler() {
        setShowModal(true)
    }

    function clsoeModalHandler() {
        setShowModal(false)
    }

    async function exportHandler() {
        setLoading(true)
        let allFilters = []
        filtersData.forEach(element => {
            allFilters = [...allFilters, ...element.items]
        });

        let reqBody = {
            ...selectedExceptions,
            ...selectedFilters,
            ...(searchParams || {})
        }

        // if (allFilters.some(item => !item.selected)) {
        //     reqBody.fields = allFilters.filter(item => item.selected).map(item => item.key)
        // }

        reqBody.fields = allFilters.filter(item => item.selected).map(item => item.key)

        if (orderFilters) {
            reqBody.order_by = `${orderFilters.group}.${orderFilters.label}`
            reqBody.order_by_direction = orderFilters.isDesc ? 'desc' : 'asc'
        }

        let response = await exportStandardWorkQ(userToken, workq.slug, reqBody)
  
        if (response && response.errorMessage) {
            dispatch(notificationActions.setError(response))
        } else {            
            dispatch(notificationActions.setError({errorMessage: `Work Q data queued successfully`, type: 'success'}))
            setShowModal(false)
        }  
        setLoading(false)
    }

    function setFiltersHandler(data) {
        setFilters(data)
    }

    

    return <>
        {userPermissionDisabled && <>
            {!inMenu && <BodySimpleModalV3 message={'Export'}>
                <Button click={openModalHandler}>
                    <i className="ti ti-file-arrow-right"></i>
                </Button>
            </BodySimpleModalV3>}
            {inMenu && <>
                <button onClick={openModalHandler} className={classes.export_button}>
                    {loading ? <span className="loader dark"></span> : <i className="ti ti-file-arrow-right"></i>} Export 
                </button>
            </>}
            {/* <Link to={'/exports'} title="go to exports" className="btn"><i className="ti ti-report-search"></i></Link> */}
        </>}

        {showModal && <>
            {ReactDOM.createPortal(
                <Backdrop hide={clsoeModalHandler} />,
                document.getElementById("backdrop-root")
            )}  
            {ReactDOM.createPortal(
                <Modal>
                    <ModalInnerWrapper modalTitle={'Export this Work Q'} closeModal={clsoeModalHandler} widthAuto={true}>
                        <PannelBody>
                            Choose what fields should appear in the file or select all.
                            
                        </PannelBody>
                        {workq && workq.grouped_fields && <PannelBody>
                            <ExportWorkQGroupContainer fields={workq.grouped_fields} classes={classes} setFilters={setFiltersHandler} filtersData={filtersData}/>
                        </PannelBody>}

                        <PannelBody>
                            <Button click={exportHandler} isLoading={loading}>Set and queue for export</Button>
                        </PannelBody>
                    </ModalInnerWrapper>
                    
                </Modal>,
                document.getElementById("overlay-root")
            )}                  
        </>}
    </>
}